// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

(function (M, Backbone, $, _) {
  'use strict';

  M.Model = M.Model || {};
  M.Model.Browse = M.Model.Browse || {};

  M.Model.Browse.BottomTrayItem = Backbone.Model.extend({
    idAttribute: "sku"
  });

})(M, Backbone, jQuery, _);

